import { t } from "i18next";
import { Trans } from "react-i18next";

import styles from "./Modal.module.scss";
import { Button, Icon } from "@livingmap/hippo";

interface Props {
  featureName: string | undefined;
  closeModal: () => void;
  onReopen: () => void;
}

const Reopen: React.FC<Props> = ({ featureName, closeModal, onReopen }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>{t("modals.reopen.title")}</h5>
        <button className={styles.closeButton} onClick={closeModal}>
          <Icon dataQA="close-icon" name="close" size={18} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>
          <Trans i18nKey="modals.reopen.description" values={{ featureName }}>
            <span />
          </Trans>
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="cancel-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.cancel")}
            onClick={closeModal}
          />
          <Button
            dataQA="reopen-button"
            type="location"
            size="regular"
            style="filled"
            text={t("modals.reopen.btn_labels.reopen")}
            onClick={onReopen}
          />
        </div>
      </div>
    </div>
  );
};

export default Reopen;
